import React, { Ref, TextareaHTMLAttributes, forwardRef } from 'react';

import Textarea from './Textarea';

type TextareaBoxProps = {
  hasError?: boolean;
  styleWidthSize?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

/** 원본 순서상 hasError 의 focus 색이 readOnly 보다 우선한다 (!important 였음) */
function borderClass(hasError?: boolean, readOnly?: boolean) {
  if (hasError) {
    return 'border-apps-coreProductError01 focus-within:border-apps-coreProductError01';
  }
  if (readOnly) {
    return 'border-apps-coreProductBorder focus-within:border-apps-coreProductBorder';
  }
  return 'border-apps-coreProductBorder focus-within:border-apps-corePrimary01';
}

const TextareaBox = forwardRef<HTMLTextAreaElement, TextareaBoxProps>(
  (
    { disabled, styleWidthSize = '100%', readOnly, hasError, ...props },
    ref: Ref<HTMLTextAreaElement>,
  ) => {
    return (
      <div>
        <Textarea
          disabled={disabled}
          readOnly={readOnly}
          ref={ref}
          className={`min-h-[120px] rounded-xl border border-solid px-4 py-3 ${borderClass(
            hasError,
            readOnly,
          )} ${
            readOnly || disabled
              ? 'bg-apps-coreProductDisableContainer'
              : ''
          }`}
          style={{ maxWidth: styleWidthSize }}
          {...props}
        />
      </div>
    );
  },
);

TextareaBox.displayName = 'TextareaBox';

export default TextareaBox;
